import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserPlus, FaTimes, FaMoneyBillWave, FaBuilding, FaRupeeSign, FaUser, FaUsers } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Topbar from './components/Topbar';
import SuperAdminSidebar from './components/SuperAdminSidebar';
import axios from 'axios';

function SuperAdminDashboard() {
  const navigate = useNavigate();
  const [totalFunds, setTotalFunds] = useState(0);
  const [totalDepartments, setTotalDepartments] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.warn('Authorization token not found. Please log in again.');
        return;
      }
      try {
        const apiBase = process.env.REACT_APP_SUPER_ADMIN_API_URL;
        const [fundsRes, departmentsRes, usersRes] = await Promise.all([
          axios.get(`${apiBase}fundlist.php`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${apiBase}departmentlist.php`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${apiBase}userlist.php`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);
        if (fundsRes.data.success && Array.isArray(fundsRes.data.funds)) {
          const totalFundAmount = fundsRes.data.funds.reduce((acc, fund) => acc + (parseFloat(fund.amount) || 0), 0);
          setTotalFunds(totalFundAmount);
        } else {
          setTotalFunds(0);
        }
        if (departmentsRes.data.success && Array.isArray(departmentsRes.data.departments)) {
          setTotalDepartments(departmentsRes.data.departments.length);
        } else {
          setTotalDepartments(0);
        }
        let usersCount = 0;
        if (Array.isArray(usersRes.data)) {
          usersCount = usersRes.data.length;
        } else if (Array.isArray(usersRes.data.users)) {
          usersCount = usersRes.data.users.length;
        } else if (Array.isArray(usersRes.data.data)) {
          usersCount = usersRes.data.data.length;
        }
        setTotalUsers(usersCount);
      } catch (error) {
        toast.error('Failed to fetch dashboard stats.');
        setTotalFunds(0);
        setTotalDepartments(0);
        setTotalUsers(0);
      }
    };
    fetchDashboardStats();
  }, []);

  return (
    <>
      <Topbar />
      <div className="d-flex" style={{ minHeight: 'calc(100vh - 56px)' }}>
        <SuperAdminSidebar />

        <div className="flex-grow-1 p-3 p-md-4 bg-light">
          {/* Stats cards */}
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 mb-4">
              <div className="card h-100 text-white" style={{ backgroundColor: '#17a2b8' }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="card-title">Total Fund</h5>
                      <h2 className="card-text"><FaRupeeSign /> {totalFunds.toLocaleString()}</h2>
                    </div>
                    <FaMoneyBillWave size="3em" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 mb-4">
              <div className="card h-100 text-white" style={{ backgroundColor: '#28a745' }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="card-title">Total Departments</h5>
                      <h2 className="card-text">{totalDepartments}</h2>
                    </div>
                    <FaBuilding size="3em" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 mb-4">
              <div className="card h-100 text-white" style={{ backgroundColor: '#ffc107' }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="card-title">Total Users</h5>
                      <h2 className="card-text">{totalUsers}</h2>
                    </div>
                    <FaUsers size="3em" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuperAdminDashboard